import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useEmployees } from 'api/hooks/use-employees'
import Select, { components } from 'react-select'

function EmployeeDropdown({ setFilterParams, filterParams }) {
  const [selected, setSelected] = useState('')
  const queryParams = {
    page: 1,
    perPage: 1000,
    orderBy: 'external_id',
    orderDirection: 'asc'
  }
  const { isSuccess, data: employees } = useEmployees({ params: queryParams })
  const { Option } = components

  const CustomOption = (props) => (
    <Option {...props}>
      <span className="me-1">{props.data.label}</span>
    </Option>
  )
  const SingleValue = ({ children, ...props }) => (
    <React.Fragment>
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </React.Fragment>
  )

  const options = isSuccess
    ? employees.data.map((obj) => ({
        label: obj['display_name'] || obj['external_id'],
        value: obj['id']
      }))
    : []

  useEffect(() => {
    if (filterParams.employee_id && isSuccess) {
      const selectedOption = options.find(
        (option) => option.value === filterParams.employee_id
      )
      setSelected(selectedOption)
    } else {
      setSelected('')
    }
  }, [filterParams.employee_id]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Select
      options={options}
      styles={{ zIndex: 100 }}
      value={selected}
      isClearable={true}
      placeholder="Select User"
      onChange={(val) => {
        setSelected(val)
        setFilterParams({ ...filterParams, employee_id: val?.value || '' })
      }}
      id="employee-selector"
      isOptionDisabled={(option) => option.disabled}
      components={{ SingleValue, Option: CustomOption }}
    />
  )
}

EmployeeDropdown.propTypes = {
  setFilterParams: PropTypes.func.isRequired,
  filterParams: PropTypes.object.isRequired
}

export default EmployeeDropdown
